import React, { useEffect, useState } from 'react';
const NAMES = ['José', 'Marcela', 'Carlos', 'Laura', 'Roberto', 'Felipe', 'Diego', 'Fernando', 'Pablo', 'Martín', 'Lucas', 'Nicolás', 'Tomás', 'Matías', 'Gonzalo', 'María', 'Carolina', 'Alejandra', 'Gabriela', 'Luciana', 'Valeria', 'Daniela', 'Patricia'];
const CITIES = ['Ciudad de México', 'Buenos Aires', 'Bogotá', 'Santiago', 'Lima', 'Madrid', 'Barcelona', 'Quito', 'Montevideo', 'San José', 'Medellín', 'Guadalajara', 'Córdoba', 'Rosario', 'Valparaíso', 'Caracas', 'Panamá', 'Santo Domingo', 'Asunción', 'La Paz'];
const PRODUCTS = [{
  name: 'Megapack + Academia Élite 360',
  emoji: '🏆'
}, {
  name: 'Megapack Fútbol Listo',
  emoji: '⚽'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-269">
      <div className="bg-[#020617] border border-[#22C55E]/40 rounded-xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-270">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-271">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-272">
          <div className="w-2 h-2 bg-[#22C55E] rounded-full animate-pulse" data-id="element-273" />
          <span className="text-[#22C55E] text-xs font-bold uppercase tracking-wider" data-id="element-274">
            Compra verificada
          </span>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-275">
          <span className="font-bold" data-id="element-276">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-gray-300 text-sm mb-2" data-id="element-277">
          compró{' '}
          <span className="text-[#22C55E] font-bold" data-id="element-278">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-gray-500 text-xs" data-id="element-279">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}